module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Land Ownership")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.landOwnershipList,
      "columns": _vm.landOwnershipTable.columns,
      "options": _vm.landOwnershipTable.options
    },
    scopedSlots: _vm._u([{
      key: "delete",
      fn: function(props) {
        return !_vm.formDisabled ? [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-ban",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.deleteLandOwnership(props.row.landOwnershipId)
            }
          }
        })])] : undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formDisabled),
      expression: "!formDisabled"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "name": "add",
      "disabled": !_vm.parentId
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs['landOwnershipModal'].open()
      }
    }
  }, [_vm._v("Add Land Ownership")])]), _vm._v(" "), (!_vm.formDisabled) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('modal', {
    ref: "landOwnershipModal",
    attrs: {
      "title": "Add Land Ownership"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h4', [_vm._v("Add Land Ownership")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "id": "landOwnershipForm",
      "data-vv-scope": "landOwnershipForm"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Landowner")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.landownerTypeId),
      expression: "landOwnershipDto.landownerTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.landOwnershipDto, "landownerTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.landownerTypeChange]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.landownerTypeList), function(owner) {
    return _c('option', {
      key: owner.id,
      domProps: {
        "value": owner.id
      }
    }, [_vm._v("\n                                    " + _vm._s(owner.description) + "\n                                ")])
  })], 2)])]), _vm._v(" "), ([1, 2].includes(_vm.landOwnershipDto.landownerTypeId)) ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('landOwnershipForm.landManager')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Land Manager")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.landManagerTypeId),
      expression: "landOwnershipDto.landManagerTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "landManager"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.landOwnershipDto, "landManagerTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.landManagerTypeListFiltered), function(manager) {
    return _c('option', {
      key: manager.landManagerTypeId,
      domProps: {
        "value": manager.landManagerTypeId
      }
    }, [_vm._v("\n                                    " + _vm._s(manager.description) + "\n                                ")])
  })], 2), _vm._v(" "), _c('div', [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('landOwnershipForm.landManager')),
      expression: "errors.has('landOwnershipForm.landManager')"
    }],
    staticClass: "has-error"
  }, [_vm._v("Land manager is required")])])])]) : _vm._e(), _vm._v(" "), (_vm.isInvestigation) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Survey Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.landTypeId),
      expression: "landOwnershipDto.landTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.landOwnershipDto, "landTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.landTypeList), function(land) {
    return _c('option', {
      key: land.id,
      domProps: {
        "value": land.id
      }
    }, [_vm._v("\n                                    " + _vm._s(land.description) + "\n                                ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.isInvestigation) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Acres")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.landOwnershipDto.acres),
      expression: "landOwnershipDto.acres",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.landOwnershipDto.acres)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.landOwnershipDto, "acres", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isInvestigation) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Corridor")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.landOwnershipDto.corridor),
      expression: "landOwnershipDto.corridor",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "step": ".1"
    },
    domProps: {
      "value": (_vm.landOwnershipDto.corridor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.landOwnershipDto, "corridor", _vm._n($event.target.value))
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isInvestigation) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Corridor Units")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.corridorIsFeet),
      expression: "landOwnershipDto.corridorIsFeet"
    }],
    attrs: {
      "type": "radio",
      "id": "corridorFeet",
      "value": "true"
    },
    domProps: {
      "checked": _vm._q(_vm.landOwnershipDto.corridorIsFeet, "true")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.landOwnershipDto, "corridorIsFeet", "true")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "corridorFeet"
    }
  }, [_vm._v("Feet")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.corridorIsFeet),
      expression: "landOwnershipDto.corridorIsFeet"
    }],
    attrs: {
      "type": "radio",
      "id": "corridorOther",
      "value": "false"
    },
    domProps: {
      "checked": _vm._q(_vm.landOwnershipDto.corridorIsFeet, "false")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.landOwnershipDto, "corridorIsFeet", "false")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "corridorOther"
    }
  }, [_vm._v("Other: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.landOwnershipDto.corridorOther),
      expression: "landOwnershipDto.corridorOther"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.landOwnershipDto.corridorOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.landOwnershipDto, "corridorOther", $event.target.value)
      }
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveLandOwnership()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$refs['landOwnershipModal'].close()
      }
    }
  }, [_vm._v("Close")])])])])], 1) : _vm._e(), _vm._v(" "), (_vm.isDebug) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', [_c('ul', [_c('li', [_vm._v("Props: { parentId: " + _vm._s(_vm.parentId) + ", source: " + _vm._s(_vm.source) + ", formDisabled: " + _vm._s(_vm.formDisabled) + " }")]), _vm._v(" "), _c('li', [_vm._v("landOwnershipList: " + _vm._s(_vm.landOwnershipList))]), _vm._v(" "), _c('li', [_vm._v("landOwnershipDto: " + _vm._s(_vm.landOwnershipDto))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "text-danger"
  }, [_vm._v("****** Debug ******")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d70baa6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandOwnership.vue
// module id = 915
// module chunks = 1